import { cn } from '@frontend/ui/lib/utils';
import type { HTMLAttributes } from 'react';

export const Container = ({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) => (
	<div className={cn('px-4 lg:px-6', className)} {...rest} />
);
